export default __webpack_public_path__ + "static/media/2.03f5544e.svg";